var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popTips.visible),expression:"popTips.visible"}],staticClass:"pop_container",style:({ transform: _vm.popTips.transformStyle })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop_main"},[_c('div',{staticClass:"pop_box"},[_vm._v("唐山丰南纵横码头")]),_c('div',{staticClass:"pop_arrow"},[_c('div')])])
}]

export { render, staticRenderFns }